import { inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHandlerFn } from '@angular/common/http';
import { ApplicationStateService } from '../services/application-state.service';

export const basicAuthorizationInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const applicationStateService = inject(ApplicationStateService);
  // Defaults to basic auth if request has credentials but there is no SSO Provider.
  let modifyRequest = request.withCredentials && !applicationStateService.getSSOInfo()?.provider;

  if (modifyRequest)
  {
    let authHeader = 'Basic ' + btoa(`${applicationStateService.getUsername()}:${applicationStateService.getPassword()}`);
    request = request.clone({
      setHeaders: {
        Authorization: authHeader,
      }
    });
  }

  return next(request);
}
